import { createStore, applyMiddleware, compose } from 'redux';
import { thunk } from 'redux-thunk'; // Correct way to import thunk
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; //PERSISTE X DISPOSITIVO 
import reducer from './reducers';


const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth', 'process'], // Persistir autenticación y proceso seleccionado
  blacklist: ['evidence', 'pei', 'academic', 'evaluation', 'improvementPlan', 'overview'], // No persistir otros estados
};

const persistedReducer = persistReducer(persistConfig, reducer);

const composeEnhancers =
  typeof window === 'object' &&
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
    // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
  }) : compose;

const enhancer = composeEnhancers(
  applyMiddleware(thunk),
  // other store enhancers if any
);

const store = createStore(persistedReducer, enhancer);
const persistor = persistStore(store);

export { store, persistor };
